import { State } from '@/store/modules/billing/billing.store';
import { MutationTree } from 'vuex';
import { setTotalSizeList, setTotalActiveAgents } from '@/components/Billing&usage/billing.usage.constants';
import datausage from '@/utils/templates/billing.usage.template';

const mutations: MutationTree<State> = {
  [setTotalSizeList](state: State, data: any) {
    state.totalSizeList = data;
  },
  [setTotalActiveAgents](state: State, data: any){
    state.activeAgentsListPerCapability = data;
  },
  setCurrentLicenseTab(state: State, tabName: any) {
   state.currentLicenseTab = tabName;
  }
};

export default mutations;
